import styled from "styled-components"

export const CommentsListWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`

export const PersonalCommentWrapper = styled.div`
        display: flex;
        width: 100%;
        padding: 16px 0;
        gap: 16px;
        align-items: center;
        position: relative;
        img{
            min-width: 48px;
            max-width: 48px;
            height: 48px;
        }
        .formEleContainer{
            margin-top: 0;
            margin-bottom: 0;
        }
        .sendArrow{
            position: absolute;
            right: 16px;
            top: auto;
            bottom: auto;
            cursor: pointer;
        }

`